import Auth from '@aws-amplify/auth'
import { AuthState } from '@aws-amplify/ui-components'
import { Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'

import { useNotification } from 'src/modules/notification'
import {
  Button,
  Form,
  FormikPasswordField,
  FormikTextField,
  FIELD_REQUIRED,
} from 'src/modules/ui'

import { checkUserAuthState } from '../utils'
import FormActions from './FormActions'
import FormHeader from './FormHeader'
import FormLinks from './FormLinks'
import FormLink from './FormLink'

export const LoginForm = ({
  handleSubmit,
  isSubmitting,
  onClickForgottenPassword,
}) => {
  return (
    <div>
      <FormHeader
        title="Welcome to Tried And Supplied"
        subtitle="Log in below to get started"
      />{' '}
      <Form>
        <FormikTextField
          fullWidth
          label="Email"
          margin="normal"
          name="username"
          type="email"
        />
        <FormikPasswordField
          fullWidth
          label="Password"
          margin="normal"
          name="password"
        />
        <FormLinks>
          <FormLink onClick={onClickForgottenPassword}>
            Forgotten password
          </FormLink>
        </FormLinks>
        <FormActions>
          <Button
            color="primary"
            onClick={handleSubmit}
            isLoading={isSubmitting}
            size="large"
            type="submit"
          >
            Login
          </Button>
        </FormActions>
      </Form>
    </div>
  )
}

const Login = ({ onStateChange, ...props }) => {
  const { showError } = useNotification()

  const validationSchema = Yup.object().shape({
    username: Yup.string().required(FIELD_REQUIRED),
    password: Yup.string().required(FIELD_REQUIRED),
  })
  const initialValues = { username: '', password: '' }

  const handleSubmit = async ({ username, password }) => {
    try {
      const user = await Auth.signIn(username, password)
      await checkUserAuthState(user, onStateChange)
    } catch (err) {
      if (err.code === 'NotAuthorizedException') {
        showError(err.message)
      } else if (err.code === 'UserNotFoundException') {
        showError('Incorrect username or password.')
      } else if (err.code === 'PasswordResetRequiredException') {
        onStateChange(AuthState.ForgotPassword, {
          email: username,
          reset: true,
        })
      } else {
        showError()
      }
    }
  }
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {formik => <LoginForm {...formik} {...props} />}
    </Formik>
  )
}

export default Login
